/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Guides_Restricted_InfoInputs */

const en_knp_lookup_guides_restricted_info = /** @type {(inputs: Knp_Lookup_Guides_Restricted_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some guides may be restricted based on your group membership.`)
};

const fr_knp_lookup_guides_restricted_info = /** @type {(inputs: Knp_Lookup_Guides_Restricted_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certains guides peuvent etre restreints en fonction de votre appartenance a un groupe.`)
};

const de_knp_lookup_guides_restricted_info = /** @type {(inputs: Knp_Lookup_Guides_Restricted_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige Reiseführer sind möglicherweise nur für Mitglieder bestimmter Gruppen zugänglich.`)
};

const it_knp_lookup_guides_restricted_info = /** @type {(inputs: Knp_Lookup_Guides_Restricted_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alcune guide potrebbero essere soggette a restrizioni in base all'appartenenza al gruppo.`)
};

const ru_knp_lookup_guides_restricted_info = /** @type {(inputs: Knp_Lookup_Guides_Restricted_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ к некоторым руководствам может быть ограничен в зависимости от вашего членства в группе.`)
};

const es_knp_lookup_guides_restricted_info = /** @type {(inputs: Knp_Lookup_Guides_Restricted_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algunas guías pueden tener restricciones según la membresía de su grupo.`)
};

const zh_cn2_knp_lookup_guides_restricted_info = /** @type {(inputs: Knp_Lookup_Guides_Restricted_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部分导游服务可能因您所在的团体而受到限制。`)
};

const ja_knp_lookup_guides_restricted_info = /** @type {(inputs: Knp_Lookup_Guides_Restricted_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一部のガイドは、グループのメンバーシップに基づいて制限される場合があります。`)
};

const hi_knp_lookup_guides_restricted_info = /** @type {(inputs: Knp_Lookup_Guides_Restricted_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी समूह सदस्यता के आधार पर कुछ गाइड प्रतिबंधित हो सकते हैं।`)
};

const pt_pt2_knp_lookup_guides_restricted_info = /** @type {(inputs: Knp_Lookup_Guides_Restricted_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alguns guias podem ter restrições dependendo da sua participação no grupo.`)
};

/**
* | output |
* | --- |
* | "Some guides may be restricted based on your group membership." |
*
* @param {Knp_Lookup_Guides_Restricted_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_guides_restricted_info = /** @type {((inputs?: Knp_Lookup_Guides_Restricted_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Guides_Restricted_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_guides_restricted_info(inputs)
	if (locale === "de") return de_knp_lookup_guides_restricted_info(inputs)
	if (locale === "it") return it_knp_lookup_guides_restricted_info(inputs)
	if (locale === "ru") return ru_knp_lookup_guides_restricted_info(inputs)
	if (locale === "es") return es_knp_lookup_guides_restricted_info(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_guides_restricted_info(inputs)
	if (locale === "ja") return ja_knp_lookup_guides_restricted_info(inputs)
	if (locale === "hi") return hi_knp_lookup_guides_restricted_info(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_guides_restricted_info(inputs)
	return en_knp_lookup_guides_restricted_info(inputs)
});